export function formatDecimal(
  value: string | number | null | undefined,
): string {
  if (value === null || value === undefined || value === "") return "";
  const raw = String(value);
  const parsed = Number(raw);
  if (!Number.isFinite(parsed)) return raw;
  if (parsed === 0) return "0";
  if (!/[eE]/.test(raw)) return raw;
  return raw.replace(/(\.\d*?[1-9])0+$/, "$1").replace(/\.0+$/, "");
}

export function formatRub(value: string | number | null | undefined): string {
  const formatted = formatDecimal(value);
  if (formatted === "") return "0.0";
  const parsed = Number(formatted.replace(",", "."));
  if (!Number.isFinite(parsed)) return formatted;
  return truncateToTenths(parsed).toFixed(1);
}

export function normalizeDecimalInput(
  value: string | number | null | undefined,
): string {
  const formatted = formatDecimal(value);
  return formatted === "0" ? "" : formatted;
}

function truncateToTenths(value: number): number {
  const truncated = Math.trunc(value * 10) / 10;
  return Object.is(truncated, -0) ? 0 : truncated;
}
